import { z } from 'zod';
/** Alle IDs sind UUIDv7 (Spec 3.2) — Zod prueft nur das UUID-Format. */
export const uuidSchema = z.uuid();
/** Slug: kleingeschrieben, Ziffern, Bindestriche — fuer Mandanten-URLs. */
export const slugSchema = z
    .string()
    .min(2)
    .max(64)
    .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/, 'Nur Kleinbuchstaben, Ziffern und Bindestriche.');
export const emailSchema = z.email().max(320).toLowerCase();
/** Unterstuetzte UI-Sprachen (Spec 14: de Standard, en gepflegt). */
export const LOCALES = ['de', 'en'];
export const localeSchema = z.enum(LOCALES);
export const DEFAULT_LOCALE = 'de';
//# sourceMappingURL=common.js.map